module.exports = "<ng-container #viewPort>\r\n\r\n</ng-container>\r\n"